export default "__VITE_ASSET__1af377dc__"